import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="app-footer" className="border-t border-slate-800 py-6 px-4 mt-8 print:hidden">
    <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
      <span>© {new Date().getFullYear()} Inspection des Fronts de Carrière</span>
      <div className="flex gap-4">
        <Link data-testid="footer-help-link" to="/aide" className="hover:text-cyan-400 transition-colors">Aide / Tutoriel</Link>
        <Link data-testid="footer-privacy-link" to="/confidentialite" className="hover:text-cyan-400 transition-colors">Politique de confidentialité</Link>
      </div>
    </div>
  </footer>
);
